import { ApiService } from '@/axios'

export const register_ = (data) => {
    return ApiService.postLogin('auth/local/register', data)
}
